import React from "react";
import { Box } from "@mui/material";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import { EmptyState } from "../components/ui";
import { can, canAll } from "../utils/auth";

/**
 * Wraps a route element in a permission check.
 *
 * Holding any one of `permission` is enough unless `requireAll` is set, which
 * is for a screen that needs several things at once to be worth opening. The
 * nav already hides what a session may not reach, so landing here means the
 * URL was typed, bookmarked or followed from a stale link — which is worth an
 * explanation rather than a redirect that looks like the app losing the page.
 *
 * This is a courtesy, not the boundary: the data behind every one of these
 * screens is guarded by requirePermission() on the API. Nothing here is what
 * keeps anybody out.
 */
export default function RequirePermission({ permission, requireAll = false, children }) {
  const keys = Array.isArray(permission) ? permission : [permission];

  if (requireAll ? canAll(...keys) : can(...keys)) return children;

  return (
    <Box sx={{ py: 4 }}>
      <EmptyState
        icon={LockOutlinedIcon}
        title="You don't have access to this page"
        description="Your role doesn't include this screen. Ask an administrator if you need it."
      />
    </Box>
  );
}
